import React from "react";
import { SideBarGroupSection } from "./SideBarGroupSection";
import { SideBarTitleSection } from "./SideBarTitleSection";

interface SideBarViewSectionProps {
  isExpanded: boolean;
  onToggleSidebar: () => void;
}
export const SideBarViewSection: React.FC<SideBarViewSectionProps> = ({
  isExpanded,
  onToggleSidebar,
}) => {
  return (
    <SideBarGroupSection flex="0 0 auto">
      <SideBarTitleSection
        isExpanded={isExpanded}
        onClick={onToggleSidebar}
      />
    </SideBarGroupSection>
  );
};
